<template>
    <div></div>
</template>

<script>
// import deeplink from '@/services/deeplink'
import local from '@/local'
import logger from '@/services/logger'

export default {
  created () {
    logger.setFields({
      deeplink_uuid: this.$route.params.deeplink_uuid
    })
  },
  mounted () {
    // Redirect to web app
    window.location.host = 'web-app.' + local.domain

    /*
    // Show loader
    this.$parent.$refs.loader.show()

    // Get redirect
    deeplink.redirect(this.$route.params.deeplink_uuid)
      .then(data => {
        // Local redirection
        if (data.url.indexOf('/') === 0) {
          this.$router.push({ path: data.url })
            .catch(err => { logger.error(err) })
          return
        }

        // Global redirection
        window.location = data.url
      })
      .catch(err => logger.error(err))
    */
  }
}
</script>
